import React from "react";
import Logo from "../../assets/Nutraj Logo F 22.png";
import { Link } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import { Routing } from "../shared/Routing";
import Paymentoptionlink from "../../assets/payment-img_1.png"

const Footer = () => {
  const FooterLink = [
    {
      title: "About",
      Links: [
        {
          name: "Company",
          href: Routing.Company,
        },
        {
          name: "FAQs",
          href: Routing.FAQs,
        },
        {
          name: "Contact",
          href: Routing.Contact,
        },
        {
          name: "Affiliate Join",
          href: Routing.AffiliateJoin,
        },
      ],
    },
    // {
    //   title: "Shop",
    //   Links: [
    //     {
    //       name: "Loose Leaf Tea",
    //       href: "/",
    //     },
    //     {
    //       name: "Green Teas",
    //       href: "/",
    //     },
    //     {
    //       name: "Packaged Teas",
    //       href: "/",
    //     },
    //     {
    //       name: "Teaware",
    //       href: "/",
    //     },
    //     {
    //       name: "Tea Gifts",
    //       href: "/",
    //     },
    //     {
    //       name: "Iced Tea",
    //       href: "/",
    //     },
    //   ],
    // },
    {
      title: "Help Center",
      Links: [
        // {
        //   name: "Delivery Information",
        //   href: "/",
        // },
        {
          name: "Terms & Conditions",
          href: Routing.TermsConditions,
        },
        {
          name: "Returns & Refunds",
          href: Routing.ReturnsRefunds,
        },
        {
          name: "Privacy Policy",
          href: Routing.PrivacyPolicy,
        },
        {
          name: "Shopping FAQs",
          href: Routing.ShoppingFAQs,
        },
      ],
    },
  ];

  return (
    <footer className="pt-[60px] pb-5 border-t border-gray-500 bg-[#f3f4f6ff]">
      <div className="container mx-auto px-2 md:px-6 lg:px-8 grid lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-2 grid-cols-1">
        <div className="sm:col-span-2">
          <div className="py-6 mb-7">
            <img src={Logo} alt="Nutrajun premium organic food logo" className="max-w-[250px]" />
          </div>
        </div>
          {FooterLink?.map((item, index) => (
            <div key={index} className="">
              <h2
                className={`text-gray-400 text-xs font-semibold uppercase tracking-[2px] sm:pb-8 ${
                  index === 0 ? "mt-0" : "sm:mt-0 mt-5"
                }`}
              >
                {item.title}
              </h2>
              <ul>
                {item?.Links?.map((link,i) => (
                  <li key={i}>
                    <Link
                  
                      to={link.href}
                      className="text-primary text-base leading-[30px]"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        <div>
          <h2 className="text-gray-400 text-xs font-semibold uppercase tracking-[2px] pb-8">
            get in touch
          </h2>
          <ul>
            <li>
              {/* <Link to={"https://maps.app.goo.gl/ddTaz26c3ZkRUQR17"} target="_blank" className="text-primary text-base leading-[30px]">
                *Nutrajun LLP* <br /> Plot No-51/B, 3rd Floor, <br />Office No.301, Hariram Bapa Nagar Near
                Urmi Society, Varachha, Surat, Gujarat, India - 395006
              </Link> */}
              <Link to={"https://maps.app.goo.gl/TDXKg3bPJuMVdSZE6"} target="_blank" className="text-primary text-base leading-[30px]">
                *Nutrajun LLP* <br /> 
                Surat, Gujarat, India - 395006
              </Link> 
            </li>
          </ul>
          <Link
            to={Routing.Initial}
            className="text-primary text-base leading-[30px] mb-9 block"
          >
            www.nutrajun.com
          </Link>
          <h2 className="text-gray-400 text-xs font-semibold uppercase tracking-[2px]">
            Need help? Call us.
          </h2>
          <Link
            to={"tel: +91 7567066690"}
            className="text-primary text-base leading-[30px] mb-9"
          >
            +91 7567066690
          </Link>
          <h2 className="text-gray-400 text-xs font-semibold uppercase tracking-[2px]">
            Need help? Email.
          </h2>
          <Link
            to={"mailto:Contact@nutrajun.com"}
            className="text-primary text-base leading-[30px] mb-9"
          >
            Contact@nutrajun.com
          </Link>
        </div>

      </div>
      <div className="container mx-auto px-2 md:px-6 lg:px-8 mt-16">
        <div className="bg-[#f3f4f6ff] rounded-md py-8">
          <h2 className="mb-3 text-gray-400 text-xs font-semibold uppercase tracking-[2px] text-center">
            Payments We Accept
          </h2>
          <img
            src={Paymentoptionlink}
            className="mx-auto mt-3 block"
            alt="Supported secure payment options"
          />
        </div>
      </div>
      <div className="py-7">
        <div className="container mx-auto px-2 md:px-6 lg:px-8 flex md:flex-nowrap flex-wrap gap-3 items-center sm:justify-between justify-center">
          <p className="text-primary px-4 sm:text-left text-center">
            Copyright © 2025 <span>NUTRAJUN</span>. All rights reserved
          </p>
          <div className="flex items-center gap-3">
            <Link
              to="https://www.facebook.com/profile.php?id=61571925202887"
              className="h-9 w-9 bg-[#F7F7F7] rounded-full flex items-center justify-center text-gray-400 hover:text-primary"
            > 
              <FaFacebookF />
            </Link> 
            <Link
              to="https://x.com/nutrajun"
              className="h-9 w-9 bg-[#F7F7F7] rounded-full flex items-center justify-center text-gray-400 hover:text-primary"
            >
              <FaXTwitter />
            </Link>
            <Link
              to="https://www.instagram.com/nutrajun_official/"
              className="h-9 w-9 bg-[#F7F7F7] rounded-full flex items-center justify-center text-gray-400 hover:text-primary"
            >
              <FaInstagram />
            </Link>
            <Link
              to="https://www.youtube.com/@Nutrajun_official"
              className="h-9 w-9 bg-[#F7F7F7] rounded-full flex items-center justify-center text-gray-400 hover:text-primary"
            >
              <FaYoutube />
            </Link>
            <Link
              to="https://www.linkedin.com/company/nutrajun-llp/"
              target="_blank"
              className="h-9 w-9 bg-[#F7F7F7] rounded-full flex items-center justify-center text-gray-400 hover:text-primary"
            >
              <FaLinkedinIn />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
